import { render, staticRenderFns } from "./Depts.vue?vue&type=template&id=57ab20a3&scoped=true&"
import script from "./Depts.vue?vue&type=script&lang=js&"
export * from "./Depts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ab20a3",
  null
  
)

export default component.exports